module.exports = __webpack_public_path__ + "img/bell-white.cb364c16.svg";